import React, { createElement, useState } from 'react';
import './index.scss';
import ErrorBoundary from '../../common/errorBoundary';
import ErrorComponent from '../../common/errorComponent';
import { Button, Message } from '@alifd/next';
import { fetchApplication } from '../../../api/report';
const Text = (props, ref) => {
    const { url, text, target, is4A, size, clientid, justify, __designMode } = props;
    const [error, setError] = useState(false);
    const [errmsg, setErrmsg] = useState(null);
    const openNewPage = () => {
        setError(false);
        if (__designMode == 'design')
            return;
        try {
            if (is4A) {
                if (clientid) {
                    fetchApplication(clientid).then((res) => {
                        if (res.data.toUrl) {
                            jump(res.data.toUrl);
                        }
                        else {
                            Message.error('4A地址不合法!');
                        }
                    });
                }
                else {
                    Message.error('4A标识未填写!');
                }
            }
            else {
                if (url) {
                    jump(url);
                }
                else {
                    Message.error('跳转地址未填写!');
                }
            }
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('4A跳转出错,请更新组件');
        }
    };
    const jump = (url) => {
        if (target === '_self') {
            location.href = url;
        }
        else {
            open(url);
        }
    };
    return (createElement(ErrorBoundary, null, error ? (createElement(ErrorComponent, { ref: ref })) : (createElement("div", { className: "base_bg", style: { display: 'flex', justifyContent: justify || 'flex-start' }, ref: ref },
        createElement(Button, { size: size, type: "normal", onClick: openNewPage }, text)))));
};
export default React.forwardRef(Text);
